<template>
  <div class="space-tags">
    <div class="space-tags--title">
      {{ data.title }}
    </div>
    <ul v-if="source_type != 'centre'" class="space-tags--list">
      <template  v-for="(item, index) in data.values.edges">
        <li v-bind:key="index">
          <span>{{$store.getters.language[item.node.title]}}</span>
        </li>
      </template>
    </ul>
    <ul v-else class="space-tags--list">
      <template  v-for="(item, index) in valuesList">
        <li v-bind:key="index">
          <span>{{ getDisplayTitle(item) }}</span>
        </li>
      </template>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'SpacesTags',
  data: () => ({
  }),
  props: {
      data: {
          default: null,
          type: Object
      },
    source_type: {
        default: null,
        type: String
    }
    },
  components: {
  },
  computed: {
    valuesList() {
      if (!this.data || !this.data.values) return []

      // if Relay-connection
      if (Array.isArray(this.data.values.edges)) {
        return this.data.values.edges
      }

      // If it’s just an array of strings
      if (Array.isArray(this.data.values)) {
        return this.data.values
      }

      return []
    }
  },
  methods: {
    getDisplayTitle(item) {
      // if Relay-connection
      if (item && item.node && item.node.title) {
        return this.$store.getters.language[item.node.title]
      }

      // If it’s just an array of strings
      if (item && item.title) {
        return this.$store.getters.language[item.title.trim()]
      }
      return ''
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../../scss/global/includes";

.space-tags {
  width: 100%;
  background: $light-grey;
  color: $primary-grey;
  padding: 32px;
  border-radius: 4px;
}
.space-tags--title {
  width: 100%;
  display: block;
  @include responsive-text-size('Header--13--BOLD');
  padding-bottom: 16px;
  margin-bottom: 19px;
  border-bottom: 1px solid $divider-dark;
}

.space-tags--list {
  padding: 0px 0 0 0;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 5px;
  list-style: none;
  li {
    padding: 10px 15px;
    background: #FFFFFF;
    position: relative;
    overflow: hidden;
    text-overflow: ellipsis;
    align-items: center;
    display: flex;
    &:before {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      width: 1px;
      background: $divider-light;
      content: "";
    }
  }
}
</style>
